import type { CategoryDetails, Product } from '../../graphql/codegen';
import type { PropsWithChildren } from 'react';

import { createContext, use, useRef } from 'react';

type PDPContextType = {
  product: Product;
  categoryDetails?: CategoryDetails;
};

const PDPContext = createContext<PDPContextType>({
  product: {},
  categoryDetails: undefined,
});

export const usePDPContext = () => use(PDPContext);

export const PDPContextProvider = ({
  product,
  categoryDetails,
  children,
}: PropsWithChildren<PDPContextType>) => {
  const value = useRef({
    product,
    categoryDetails,
  });

  return <PDPContext value={value.current}>{children}</PDPContext>;
};
